import { computed, ComputedRef } from 'vue';

const getDiffInHuman = (endDate?: string, startDate?: string) => {
  if (endDate && endDate !== '') {
    const msInMinute = 60 * 1000;
    const msInHour = 60 * msInMinute;
    const msInDay = 24 * msInHour;

    const end = +new Date(endDate);
    const start = startDate ? +new Date(startDate) : +new Date();

    const dateDiff = end - start;

    const leftDays = Math.ceil(dateDiff / msInDay);
    const leftHours = Math.ceil(dateDiff / msInHour);
    const leftMinutes = Math.ceil(dateDiff / msInMinute);

    let msg = '';
    if (dateDiff > 0) {
      msg = `${leftMinutes} minute`;
      msg += leftMinutes > 1 ? 's' : '';
    }
    if (dateDiff > msInHour) {
      msg = `${leftHours} hour`;
      msg += leftHours > 1 ? 's' : '';
    }
    if (dateDiff > msInDay) {
      msg = `${leftDays} day`;
      msg += leftDays > 1 ? 's' : '';
    }

    if (dateDiff > 0) {
      return `in ${msg}`;
    }
    if (dateDiff < 0) {
      return `${msg} ago`;
    }
    return 'now';
  }

  return endDate;
};

/**
 * Calculates the difference between two dates and returns it in a human-readable format.
 * @param endDate - The end date.
 * @param startDate - The start date (optional). If not provided, the current date will be used.
 * @returns An object containing the difference between the two dates in a human-readable format.
 */
export const useDateDiff = (endDate: ComputedRef<string | undefined>, startDate?: ComputedRef<string | undefined>) => {
  const dateDiffInHuman = computed(() => getDiffInHuman(endDate.value, startDate?.value));

  return { dateDiffInHuman };
};
